import React, { FC } from 'react';

import { Outlet } from 'react-router-dom';

const DirectionsTrainingPage: FC = () => <Outlet />;

export default DirectionsTrainingPage;
